/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2019-01-04 12:05:47
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-04 13:23:27
 */
import { getChannelById } from '@/api/ajax.js';
export var getZoneName = {
  data: function data() {
    return {
      zone_name: ''
    };
  },
  methods: {},
  created: function created() {
    var _this = this;

    if (this.$route.query.zone_id) {
      getChannelById({
        channelId: this.$route.query.zone_id
      }).then(function (res) {
        _this.zone_name = res.data.data;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.zone_id = '';
  }
};